import { render, staticRenderFns } from "./comp_HomeProductCarouselSection.vue?vue&type=template&id=b534c800&scoped=true&"
import script from "./comp_HomeProductCarouselSection.vue?vue&type=script&lang=js&"
export * from "./comp_HomeProductCarouselSection.vue?vue&type=script&lang=js&"
import style0 from "./comp_HomeProductCarouselSection.vue?vue&type=style&index=0&id=b534c800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b534c800",
  null
  
)

export default component.exports